<template>
  <input
      type="text"
      :id="id"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
      :class="{'tw-border-error': hasError}"
      class="border-1 border-solid w-full p-2.5 leading-6 border-border rounded-6 shadow-none outline-none focus:border-signableSecondary2Shade3 focus:shadow-input"
  />
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: {
      type: String,
    },
    id: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
